// ── DASH.B1 — Zone 1: Status Strip ──────────────────────────────────────────
//
// Full-width row of 4–6 role-tuned KPI tiles (design doc §5 / §5.2). flex-row,
// gap 16px, wraps on narrow viewports. Tiles ALWAYS render (showing '0' / '—'
// when there's no data) — they never collapse (§11.4).

import KpiTile from './KpiTile';
import { getKpiTileData, TILES_WITHOUT_OVERVIEW_DATA } from './kpiTileData';
import type { KpiTileId } from '../../config/dashboardRoleConfig';
import type { DashboardOverview } from '../../types/dashboard';

export interface DashboardZone1StatusProps {
  tiles: KpiTileId[];
  overview: DashboardOverview | null;
  loading: boolean;
}

export default function DashboardZone1Status({ tiles, overview, loading }: DashboardZone1StatusProps) {
  const showSkeleton = loading && !overview;

  // Drop tiles with no /overview data source (FIX 3) — a live role must never
  // see a tile that can never populate. The config keeps the full §5.2 tile
  // list per role; the filtering is a presentation concern here. comingSoon
  // tiles and backed tiles that show a real '0' are NOT filtered.
  const renderable = tiles.filter((id) => !TILES_WITHOUT_OVERVIEW_DATA.has(id));

  return (
    <div
      data-testid="dashboard-zone1"
      style={{ display: 'flex', flexWrap: 'wrap', gap: 16, alignItems: 'stretch' }}
    >
      {showSkeleton
        ? renderable.map((id) => <KpiTile key={id} skeleton />)
        : renderable.map((id) => {
            const data = getKpiTileData(id, overview as DashboardOverview);
            return <KpiTile key={id} {...data} />;
          })}
    </div>
  );
}
